import React, { useEffect } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useNavigate } from 'react-router-dom';

const CustomerTable = ({data}) => {
    const history = useNavigate();
    const handleDelete = (id)=>{

    }
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'))
      
        const table = $('#dataTable').DataTable({
        data: data,
        responsive:true,
        pageLength: 10,
         columns: [
            { data: 'id' },
            { data: 'name' },
            { data: 'phone' },
           
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
                <button class="btn btn-success view-btn" data-id="${row.id}"><i class="ph ph-eye"></i></button>
                <button class="btn btn-primary edit-btn" data-id="${row.id}"><i class="ph ph-pencil"></i></button>
                <button class="btn btn-danger delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i></button>
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
            
        });
        $('#dataTable tbody').on('click', '.edit-btn', function () {
          const id = $(this).data('id');
        //   history(`/edit-appointment/${id}`); // Navigate to the edit page
        });
        $('#dataTable tbody').on('click', '.view-btn', function () {
          const id = $(this).data('id');
        //   history(`/view-appointment/${id}`); // Navigate to the edit page
        });
    
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, []);
    return (
        <div className="card basic-data-table">
            <div className="card-header ">
                <div className='row'>

                <h5 className="card-title mb-0 col-md-6">List of Staff</h5>
                <div className='col-md-6 text-end'>

                <Link to={'/add-staff'} className="btn btn-primary" style={{background:'#db6f2f',borderColor:'#db6f2f'}} >Add New</Link>
                </div>
                </div>
            </div>
            <div className="card-body">
                <table
                    className="table bordered-table mb-0"
                    id="dataTable"
                    data-page-length={10}
                >
                    <thead>
                        <tr>
                            <th scope="col">
                                <div className="form-check style-check d-flex align-items-center">
                                    
                                    <label className="form-check-label">S.L</label>
                                </div>
                            </th>
                            
                            <th scope="col">Name</th>
                            <th scope="col">Phone</th>
                            
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                   <tbody>
                    
                   </tbody>
                </table>
            </div>
        </div>

    )
}

export default CustomerTable